import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiUrl } from './config';
import { Route } from './routes';
import { storage } from './utils/localstorage-utils';

export type FetchMethod = "GET" | "POST" | "DELETE" | "PUT";

export interface IBlob {
  blob: Blob;
  fileName: string;
}

export enum EBlobType {
  PDF = "application/pdf",
  CSV = "text/csv",
}

export interface ISignal {
  signal: AbortSignal;
}

type TBody = BodyInit | null | undefined;

interface IOptions {
  method?: FetchMethod;
  body?: TBody;
  signal?: AbortSignal;
}

export const useCustomFetch = () => {
  const navigate = useNavigate();

  const customFetch = useCallback(async function <T>(
    url: string,
    options: IOptions = {
      method: "GET",
    }
  ): Promise<[T, Response]> {
    const fetchOptions: RequestInit = {
      ...options,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json;charset=UTF-8",
        "X-Auth-AccessToken": storage.getToken() || "",
        "X-Auth-Email": storage.getEmail() || "",
        "X-Auth-Firebase-Token": storage.getFirebaseToken() || "",
      },
      credentials: 'include'
    };

    const resp = await fetch(`${apiUrl}${url}`, fetchOptions);

    const data = await resp.json();
    if (resp.status === 401) {
      if (!url.includes('/json/users/logout')) {
        navigate(Route.logout);
      }
      return [data, resp];
    }

    if (!resp.ok) {
      if (typeof data === 'string') {
        throw new ErrorResponse([data]);
      }
      throw new ErrorResponse(data.messages ? data.messages : [data.detail || 'An error occurred']);
    }
    return [data, resp];
  }, [navigate]);

  return customFetch;
}



export class ErrorResponse extends Error {
  messages: string[] = [];
  constructor(messages: string[]) {
    super("");
    this.messages = messages;
  }
}

/*

.then(async res => {
      if (res.ok) {
        return {
          data: await res.json(),
          response: res
        };
      }
      return res.json().then(error => {
        throw new Error(error.Message);
      });
    })
    .catch(error => {
      if(error instanceof Error) {
        throw error;
      } else {
        throw new Error(error);
      }
    });

  */
